import { Component } from '@angular/core';

import { UnifiedOrderInfoTableComponent } from '../unified-order-info-table.component';

@Component({
  standalone: false,
  selector: 'simplify-order-info-table',
  templateUrl: './simplify-order-info-table.component.html',
  styleUrls: ['./simplify-order-info-table.component.scss']
})
export class SimplifyOrderInfoTableComponent extends UnifiedOrderInfoTableComponent {

}
